<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 系统管理
                </el-breadcrumb-item>
				<el-breadcrumb-item>会计代码</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-select v-model="query.accountingType" placeholder="请选择财务类型">
					<el-option key="" label="请选择财务类型" value=""></el-option>
					<el-option v-for="item in accountingTypeKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
                <el-input v-model="query.name" placeholder="名称" class="handle-input mr10"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
				:cell-style="{padding:4+'px'}"
				stripe
            >
                <el-table-column type="selection" width="55" align="center"></el-table-column>
				<el-table-column prop="accountingType" label="类型" :formatter="accountingTypeFormat"></el-table-column>
                <el-table-column prop="name" label="名称"></el-table-column>
				<el-table-column prop="remark" label="备注"></el-table-column>
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.$index, scope.row)"
                        >编辑</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            class="red"
                            @click="handleDelete(scope.$index, scope.row)"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
			<div class="record-a-d">
				<el-button
                    type="warning"
                    icon="el-icon-delete"
                    class="handle-del mr10"
                    @click="delAllSelection"
                >批量删除</el-button>
				<el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-del mr10"
                    @click="handleAdd"
                >添加记录</el-button>
			</div>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false :title="title" :visible.sync="editVisible" width="40%">
            <el-form ref="form" :model="form" label-width="80px" :rules="rules">
				<el-tabs v-model="activeName" type="card">
					<el-tab-pane label="基本信息" name="baseTab">
						<el-form-item label="类型" prop="accountingType">
							<el-select v-model="form.accountingType" placeholder="请选择财务类型">
								<el-option key="" label="请选择财务类型" value=""></el-option>
								<el-option v-for="item in accountingTypeKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="名称" prop="name">
							<el-input v-model="form.name"></el-input>
						</el-form-item>
						<el-form-item label="备注">
							<el-input type=textarea :rows=10 v-model="form.remark"> </el-input>
						</el-form-item>
					</el-tab-pane>
					<el-tab-pane label="内容" name="contentTab">
						<el-form-item label="内容配置" prop="content">
							<el-input type=textarea :rows=20 v-model="form.content"> </el-input>
						</el-form-item>
					</el-tab-pane>
				</el-tabs>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { fetchAccountingConfigData, saveAccountingConfig, deleteAccountingConfig, getAccountingConfig, getAccountingTypeKV} from '../../../api/index';
export default {
    name: 'accounting-config',
    data() {
		let checkNum = (rule, value, callback) => {
			const mailReg = /^[0-9]*$/
			if (value) {
				if (mailReg.test(value)) {
					callback()
				} else {
					callback(new Error('编码为数值型'));
				}
			} else {
				callback(new Error('请输入编码'));
			}
		}
        return {
            query: {
                code: '',
                name: '',
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1,
			title:"",
			isDisabled:false,
			rules: {
                accountingType: [{ required: true, validator: checkNum, trigger: 'blur' }],
                name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
				content: [{ required: true, message: '请输入代码配置内容', trigger: 'blur' }]
            },
			controll:{},
			accountingTypeKV:[],
			activeName:"baseTab"
        };
    },
    created() {
        this.getData();
		this.getAccountingType();
    },
    methods: {
		getAccountingType() {
			getAccountingTypeKV().then(res => { 
				if (res.code == 0 ) {
					this.accountingTypeKV = res.data;
				} else {
					this.$message.error(res.message);
				}
            });
		},
		accountingTypeFormat(row, column, cellValue) {
			let index = this.accountingTypeKV.findIndex(item => {
				if (item.key === cellValue) {
					return true;
				}
			});
			if (index === -1) return cellValue;
			return this.accountingTypeKV[index].value;
		},
        // 获取 easy-mock 的模拟数据
        getData() {
            fetchAccountingConfigData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error(res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteAccountingConfig([row.id]).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        delAllSelection() {
            const length = this.multipleSelection.length;
			if (length == 0) {
				this.$message.error(`请选择要删除的记录！`);
			}
            let ids = [];
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
				ids.push(this.multipleSelection[i].id)
            }
			this.$confirm('确定要删除选中的记录吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteAccountingConfig(ids).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
				})
				.catch(() => {});
        },
		//添加操作
		handleAdd() {
			this.form = {};
			this.isDisabled = false;
			this.title = "添加新纪录";
			this.editVisible = true;
			this.activeName = "baseTab";
		},
        // 编辑操作
        handleEdit(index, row) {
            this.idx = index;
            //this.form = row;
			this.isDisabled = true;
			this.title = "编辑";
			getAccountingConfig(row.id).then(res => {
				if (res.code == 0) {
					this.form = res.data;
					this.editVisible = true;
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
        },
        // 保存编辑
        saveEdit() {
			this.$refs.form.validate(valid => {
				if (valid) {
					saveAccountingConfig(this.form).then(res => {
						if (res.code == 0) {
							this.$message.success('保存成功！');
							this.editVisible = false;
							//this.$message.success(`修改第 ${this.idx + 1} 行成功`);
							if (typeof(this.form.id) == "undefined") {
								this.getData();
							} else {
								this.$set(this.tableData, this.idx, this.form);
							}
						} else {
							this.$message.error(`保存失败！` + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
